export default __webpack_public_path__ + "static/media/p2p-banners-ms.8828146f.webp";